let navigateFn: (path: string) => void;

export const setGlobalNavigate = (navigate: (path: string) => void) => {
  navigateFn = navigate;
};

export const getGlobalNavigate = () => navigateFn;
